<template>
  <div class="new-event-coupons">
    <div class="relative flex items-center justify-between mb-48">
      <h3 class="text-white text-2xl font-medium">{{ $t('newEvent.coupon.title') }}</h3>
      <div v-show="!isDrawerSize && swiperButtonShow" class="flex items-center justify-center" style="width: fit-content; gap: 8px; margin-right: 60px">
        <div class="flex items-center justify-center" :class="`swiper-button-prev swiper-button-prev-${cid}`" slot="button-prev">
          <i class="owl-direction-left"></i>
        </div>
        <div class="flex items-center justify-center" :class="`swiper-button-next swiper-button-next-${cid}`" slot="button-next">
          <i class="owl-direction-right"></i>
        </div>
      </div>
    </div>
    <div v-if="!isDrawerSize" class="flex flex-row relative mx-auto container-anchor">
      <swiper :options="options" :ref="`swiper-${cid}`" class="w-full h-full">
        <swiper-slide v-for="(coupon, index) in coupons" :key="`coupon-${index}`" class="coupon relative flex" style="border-radius: 20px;">
          <div class="left w-2/3 border-r border-grey-light border-dashed flex flex-col justify-between ml-16" :class="!coupon.custom ? 'cursor-pointer' : ''" @click="showCouponModal(coupon)">
            <div>
              <p class="coupon_name font-bold leading-normal text-xl">{{ displayCouponCount(coupon) }}</p>
              <p class="text-sm mt-4">{{ coupon.name }}</p>
            </div>
            <div class="leading-normal text-sm flex items-center justify-between">
              <p class="">{{ $t('newEvent.coupon.code') }}：{{ coupon.code }}</p>
              <i class="owl-direction-right pr-12 text-lg text-grey-dark cursor-pointer"></i>
            </div>
          </div>
          <div class="right w-1/3 flex items-center align-middle justify-center">
            <div class="bg-black rounded-full text-white text-base leading-normal px-16 py-8 cursor-pointer" @click="addCoupon(coupon.code)">{{ $t('newEvent.coupon.receive') }}</div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div v-else class="relative flex flex-col items-center" style="gap: 16px">
      <div v-for="(coupon, index) in coupons" :key="`coupon-${index}`" class="coupon relative flex overflow-hidden" style="border-radius: 20px;">
        <div class="left w-2/3 border-r border-grey-light border-dashed flex flex-col justify-between ml-16 cursor-pointer" @click="showCouponModal(coupon)">
          <p class="coupon_name font-bold leading-normal text-xl">{{ displayCouponCount(coupon) }}</p>
          <p class="text-sm -mt-24">{{ coupon.name }}</p>
          <div class="leading-tight text-sm flex items-center justify-between">
            <p class="">{{ $t('newEvent.coupon.code') }}：{{ coupon.code }}</p>
            <i class="owl-direction-right pr-12 text-lg text-grey-dark cursor-pointer"></i>
          </div>
        </div>
        <div class="right w-1/3 flex items-center align-middle justify-center">
          <div class="bg-black rounded-full text-white text-sm leading-normal px-16 py-4 cursor-pointer" @click="addCoupon(coupon.code)">{{ $t('newEvent.coupon.receive') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import numeral from 'numeral'
import clipboard from '@/utils/clipboard'

import fullPageModal from '@/components/modals/fullPageModal'
import couponDetail from '@/components/couponDetail'

export default {
  name: 'NewEventCoupons',
  props: {
    coupons: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      cid: this._uid,
      options: {
        loop: false,
        preventInteractionOnTransition: true,
        slideToClickedSlide: false,
        navigation: {
          nextEl: `.swiper-button-next-${this._uid}`,
          prevEl: `.swiper-button-prev-${this._uid}`
        },
        spaceBetween: 24,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        initialSlide: 0,
        pagination: {
          el: '.swiper-pagination'
        }
      },
      swiperButtonShow: false
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
      isDrawerSize: 'isDrawerSize',
      currencySign: 'user/currencySign',
      initWidth: 'initWidth'
    })
    // swiperButtonShow() {
    //   if ((this.initWidth >= 480 && this.initWidth <= 760) && this.coupons.length > 1) {
    //     return true
    //   } else if ((this.initWidth > 760 && this.initWidth <= 1100) && this.coupons.length > 2) {
    //     return true
    //   } else if (this.initWidth > 1100 && this.coupons.length > 3) {
    //     return true
    //   }
    //   return false
    // }
  },
  methods: {
    ...mapActions([
      'user/addCoupons'
    ]),
    displayCouponCount: function (coupon) {
      if (coupon.discountUnit === 'percent') {
        return numeral((Number(1 - coupon.discountValue) * 100)).format('0[.]00') + '% OFF'
      } else {
        return this.currencySign + coupon.discountValue
      }
    },
    addCoupon: function (couponCode) {
      return this['user/addCoupons'](couponCode)
        .then(({ status, data }) => {
          if (status === 200) {
            this.$message({
              message: this.$t('exchangeCompletion') + this.$t('redeemSaved'),
              type: 'success'
            })
          } else {
            if (status === 30001 || status === 30002) {
              this.$message({
                message: this.$t('notLogin.msg2'),
                type: 'error'
              })
            } else {
              this.$message({
                message: data.message,
                type: 'error'
              })
            }
          }
        })
    },
    copyCoupon: function (coupon, $event) {
      window.dataLayer.push({
        event: 'super-taste_discount',
        key: coupon.name
      })
      clipboard(coupon.code, $event, {
        success: `[${this.$t('couponHadBeenCopy')}] ${coupon.code}`
      })
    },
    goToLineAt (coupon) {
      window.dataLayer.push({
        event: 'super-taste_discount',
        key: coupon.name
      })
      window.open(coupon.link, '_blank')
    },
    showCouponModal (coupon) {
      if (coupon.custom) return false
      this.$modal.show(fullPageModal,
        {
          // 輸入內容
          context: couponDetail,
          data: {
            coupon
          }
        },
        {
          adaptive: true,
          name: 'couponDetail',
          clickToClose: true,
          height: 'auto',
          width: '95%',
          minWidth: 350,
          maxWidth: 600,
          scrollable: true
        }
      )
    }
  },
  mounted () {
    // console.log('swiper container width', this.$refs[`section-recommend-hotel-${this.cid}`].swiper.width)
    // console.log('all slides width', this.$refs[`section-recommend-hotel-${this.cid}`].swiper.virtualSize)
    this.$nextTick(() => {
      const swiperWidth = this.$refs[`swiper-${this.cid}`]?.swiper?.width
      const swiperSlideWidth = this.$refs[`swiper-${this.cid}`]?.swiper?.virtualSize
      if (swiperSlideWidth > swiperWidth) {
        this.swiperButtonShow = true
      } else {
        this.swiperButtonShow = false
      }
    })
  }
}
</script>
<style lang="sass">
@import '@/assets/style/_mixins.sass'
.new-event-coupons
  @apply w-full
  .coupon
    @apply p-16 bg-white
    min-width: 343px
    max-width: 343px
    height: 132px
    // @screen md
    //   @apply p-24
    //   height: 132px
    &::before
      @apply absolute rounded-full
      background:
        color: black
        repeat: repeat
        position: top left
      width: 50px
      height: 50px
      top: 50%
      left: -3%
      transform: translate(-50%, -50%)
      z-index: 1
      content: ''
    &::after
      @apply absolute rounded-full
      background:
        color: black
        repeat: repeat
        position: top left
      width: 50px
      height: 50px
      top: 50%
      right: -3%
      transform: translate(50%, -50%)
      z-index: 1
      content: ''
    &_name
      @include ellipsis(2)
  .swiper-container
    @apply px-16
    @screen sm
      @apply px-0
    .swiper-slide
      max-width: 282px
      max-height: 100px
    .coupon
      @apply p-16 bg-white py-24
      min-width: auto
      max-width: 311px
      height: 132px
  .swiper-button-prev, .swiper-button-next
    @apply outline-none #{!important} rounded-full bg-grey-darkest
    position: relative !important
    background-image: none !important
    width: 35px !important
    height: 35px !important
    margin-top: 0px !important
    z-index: 8
    i[class*=owl-direction]
      @apply text-white
      font-size: 18px
  .swiper-button-prev
    left: initial
    // @screen sm
    //   left: -5px !important
  .swiper-button-next
    right: initial
    // @screen sm
    //   right: -5px !important
  .swiper-button-disabled
    @apply cursor-not-allowed bg-grey-darker
</style>
